<template>
  <div
    v-if="getIsDisplay()"
    class="cs-accountList-payment"
    :class="{'cs-redLabel':!payment.IsChecked}"
  >
    <!-- <el-row v-if="!this.payment.Id">
      <span>{{ getDateText()}}</span>
    <span>{{ getUserName()}}</span>
    </el-row>
    <el-row v-else> -->
    <el-row>
      <span v-if="!!payment.PaymentTypeId">{{ getAmount() | toCurrency(currency) }}</span>
      <span v-if="payment.Tax > 0">(税{{ payment.Tax | toCurrency(currency)}})</span>
      <span v-if="payment.ServiceCharge > 0">(手续费{{ payment.ServiceCharge | toCurrency(currency)}})</span>
      <span v-if="!!payment.PaymentTypeId">{{getIsMemberCard()}}</span>
      <img v-if="!!payment.PaymentTypeId" :src="getImgSrc()">
      <span>{{ getDateText()}}</span>
      <span v-if="isAutonomousPayment">学生自主付款</span>
      <span v-else>{{ getUserName()}}</span>
      <div v-if="isAutonomousPayment && !!payment.PaymentTypeId && payment.PaymentTypeId == 9" >
        <el-button :loading="isDownloading" type="text" size="medium" @click="downloadPaymentFile()">查看截图</el-button>
        <span v-html="getEMTDesc()"></span>
      </div>
      <i
        v-if="payment.IsChecked && !status.isChecking"
        class="fa fa-check"
        aria-hidden="true"
      ></i>
      <span v-if="!payment.IsChecked">(待处理)</span>
      <el-checkbox
        v-if="status.isChecking"
        @change="onCheckChange"
        v-model="payment.IsChecked"
      ></el-checkbox>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-accountList-payment {
  span {
    display: inline-block;
    margin-right: 1px;
  }
  img {
    display: inline-block;
    width: 20px;
    margin-right: 5px;
    margin-left: 5px;
  }
  .fa-check {
    color: green;
  }
}
</style>

<script>
import { getPaymentImgList, downloadFile } from "../../../config/mUtils.js";
import { getBlobFileUrlById, downloadFileToBlob } from "@/service/blobStorage.service";

export default {
  props: {
    data: {},
    columnData: {},
    status: {}
  },
  data() {
    return {
      currency: 2, //default as CAD
      isAutonomousPayment: false,
      isDownloading: false,
      payment: {},
      paymentImgList: [],
      imgUrlCash: require("../../../assets/payment-cash.png")
    };
  },
  components: {},
  created() {
    this.getCurrency();
    this.payment = this.getPayment();
    this.paymentImgList = getPaymentImgList();
  },
  methods: {
    onCheckChange() {},
    getServiceCharge() {},
    getIsMemberCard() {
      if (this.payment.IsMemberCard) {
        return "会员卡";
      }
      return "";
    },
    getCurrency(){
      if (this.data && this.data.Currency){
        this.currency = this.data.Currency;
      }
    },
    getIsDisplay() {
      return !!this.payment.Id || !!this.payment.UserName;
    },
    getDateText() {
      return this.payment.DateText;
    },
    getUserName() {
      return this.payment.UserName;
    },
    getImgSrc() {
      return this.paymentImgList[this.payment.PaymentTypeName];
    },
    getAmount() {
      return this.payment.Amount + this.payment.Tax + this.payment.ServiceCharge;
    },
    getPayment() {
      if (this.data){
        this.isAutonomousPayment = this.data.IsAutonomousPayment;
      }
      let payment = null;
      if (!!this.data && !!this.columnData) {
        if (this.columnData.Name == "AccountPayment1") {
          payment = this.data.AccountPayment1;
        } else if (this.columnData.Name == "AccountPayment2") {
          payment = this.data.AccountPayment2;
        } else if (this.columnData.Name == "AccountPayment3") {
          payment = this.data.AccountPayment3;
        } else if (this.columnData.Name == "AccountPayment4") {
          payment = this.data.AccountPayment4;
        }
      }
      if (!payment) {
        payment = {
          Amount: "",
          PaymentTypeName: "",
          DateText: "",
          UserName: "",
          PaymentTypeId: 0
        };
      }

      return payment;
    },
    downloadPaymentFile() {
      if (this.payment){
        this.isDownloading = true;
        if (this.payment.ImageFiles && this.payment.ImageFiles.length > 0){
          for(let i = 0; i < this.payment.ImageFiles.length; i ++){
            let fileId = this.payment.ImageFiles[i].FileStorageId;
            getBlobFileUrlById(fileId)
              .then((result) => {
                if (!!result && result.success) {
                  let { Url, FileName } = result.data;
                
                  downloadFileToBlob(Url, 0).then((res) => {
                    downloadFile({data: res.data, filename: FileName}, true);
                    this.isDownloading = false;
                  });
                
                } else {
                  if (!!result.message) {
                    this.$message.error(result.message);
                  }
                  this.isDownloading = false;
                }
              })
              .catch(() => {});
              }
        }
      }
    },
    getEMTDesc(){
      let desc = "";
      if (this.payment && this.payment.PaymentTypeId && this.payment.PaymentTypeId == 9){
       
        if (this.payment.Name){
          desc = "姓名: " + this.payment.Name;
        }
        if (this.payment.Email){
          desc += "<br/>邮箱: " + this.payment.Email;
        }
        
      }
      return desc;
    }
  },
  watch: {
    data: function() {
      this.payment = this.getPayment();
      this.getCurrency();
    },
    columnData: function() {
      this.payment = this.getPayment();
    },
    status: function() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/accountListPaymentCell.vue